import React from 'react';
import { useFormikContext } from 'formik';
import { TextField } from '@mui/material';

function TextFieldContext({
  name, label, onBlurCallback = () => {}, ...rest
}) {
  const { getFieldProps, getFieldMeta, setFieldTouched } = useFormikContext();
  const fieldProps = getFieldProps(name);
  const fieldMeta = getFieldMeta(name);

  return (
    <TextField
      {...fieldProps}
      {...rest}
      label={label}
      variant="outlined"
      fullWidth
      onBlur={() => {
        setFieldTouched(name, true);
        onBlurCallback();
      }}
      error={fieldMeta.touched && fieldMeta.error}
      helperText={fieldMeta.touched && fieldMeta.error}
    />
  );
}

export default TextFieldContext;
